module.exports = {"development":{"backendUrl":"http://localhost:6002","socketUrl":"http://localhost:6002"},"production":{"backendUrl":"http://ws.sutda-ubuntu.test","socketUrl":"http://ws.sutda-ubuntu.test"}}


//////////////////
// WEBPACK FOOTER
// ./src/app_config.json
// module id = 197
// module chunks = 0